<div class="top-nav-desktop">
  <div class="profile">
    Hi, {{ profile().name }} |
    <a href="#" (click)="logoutClicked.emit()">Logout</a>
  </div>
</div>

<div class="top-nav-mobile">
  <button class="menu-button" (click)="toggleMenu()">
    @if(hasAccess() === false){
      <button class="menu-button" (click)="logoutClicked.emit()">
        <div class="logout">Logout</div>
      </button>      
    }
    @else {
      @if(navService.isMenuOpen()){
        <img src="./assets/navbar/xmark-regular.svg" alt="Close Menu" width="20" height="20">
      }
      @else {
        <img src="./assets/navbar/black-hamburger.svg" alt="Open Menu" width="56" height="38">
      }
    }
  </button>


</div>